"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Process = void 0;
var EntitiesHelper_1 = require("../../helpers/EntitiesHelper");
var Process = (function () {
    function Process(version, activities, process, defaultType) {
        this._version = version;
        this._activities = activities;
        this._process = process;
        this._defaultType = defaultType;
    }
    Object.defineProperty(Process.prototype, "version", {
        get: function () {
            return this._version;
        },
        set: function (aVersion) {
            this._version = aVersion;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Process.prototype, "process", {
        get: function () {
            return this._process;
        },
        set: function (aProcess) {
            this._process = aProcess;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Process.prototype, "activities", {
        get: function () {
            return this._activities;
        },
        set: function (listOfActivities) {
            this._activities = listOfActivities;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Process.prototype, "defaultType", {
        get: function () {
            return this._defaultType;
        },
        set: function (aDefaultType) {
            this._defaultType = aDefaultType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Process.prototype, "$id", {
        get: function () {
            return EntitiesHelper_1.EntHelper.GetIdFromName(this.process);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Process.prototype, "$nodeIds", {
        get: function () { return this._nodeIds; },
        set: function (nodeIds) { if (this._nodeIds === undefined)
            this._nodeIds = nodeIds; },
        enumerable: false,
        configurable: true
    });
    return Process;
}());
exports.Process = Process;
//# sourceMappingURL=Process.js.map